<div class="settings-modal-dialog__wrapper">
  <div class="settings-modal-dialog__top">
    <div mat-dialog-title>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fal fa-file-pdf i-16 mr-4"></i>
          <span>Export</span>
        </div>
        <div>
          <button *ngIf="!exporting" trgButton class="dialog-close-btn" (click)="cancel()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </div>
    <div mat-dialog-content class="fs-14 d-flex flex-dir-column">
      <div class="c-blue bold border-b-dotted-1 brc-grey-1 pb-4 mb-12">
        <span>Export: <strong class="c-black">{{title}}</strong></span>
      </div>
      <app-spinner *ngIf="loading">
      </app-spinner>
      <div class="mb-20" [hidden]="failed || success">
        <span *ngIf="!exporting && !loading">
          <span>Specify the file type for the exported document</span>
        </span>
        <span *ngIf="exporting">Please wait while the document is generated...</span>
      </div>
      <div class="settings-section" [class.mb-20]="failed && !exporting" [hidden]="exporting || success || loading">
        <div class="settings-section__group">
          <label class="text-right settings-section-input-offset justify-content-right">Type:</label>
          <div class="settings-section__input">
            <span>{{visualInfo?.pbiChartType.title}}</span>
          </div>
        </div>
        <div class="settings-section__group mb-10" *ngIf="formats.length > 1">
          <label class="text-right settings-section-input-offset justify-content-right">File Type:</label>
          <div class="settings-section__input max-w-200">
            <mat-select class="trg-outline" panelClass="trg-outline-dropdown min-w-200 max-w-200" [(ngModel)]="format" (ngModelChange)="modelChanged()">
              <mat-option *ngFor="let f of formats" [value]="f.value">{{f.title}}</mat-option>
            </mat-select>
          </div>
        </div>
        <ng-container *ngIf="(format == 4 || format == 0) && tableFormats.length > 1">
          <div class="settings-section__group mb-10">
            <label class="text-right settings-section-input-offset justify-content-right">Layout:</label>
            <div class="settings-section__input max-w-200">
              <mat-select class="trg-outline" panelClass="trg-outline-dropdown min-w-200 max-w-200" [(ngModel)]="tableFormat" (ngModelChange)="modelChanged()">
                <mat-option *ngFor="let tf of tableFormats" [value]="tf.value">{{tf.title}}</mat-option>
              </mat-select>
            </div>
          </div>
        </ng-container>
        <div class="settings-section__group" *ngIf="format == 4">
          <label class="text-right settings-section-checkbox-offset justify-content-right">Formatted:</label>
          <div class="settings-section__input">
            <trg-checkbox appearance="square" [(value)]="style" (valueChange)="modelChanged()"></trg-checkbox>
          </div>
        </div>
        <div class="settings-section__group" *ngIf="features?.visualExport?.excelChartImage && format == 4">
          <label class="text-right settings-section-checkbox-offset justify-content-right">Chart Image:</label>
          <div class="settings-section__input">
            <trg-checkbox appearance="square" [(value)]="chartImage" (valueChange)="modelChanged()"></trg-checkbox>
          </div>
        </div>
        <ng-container *ngIf="layoutOptions">
          <div class="settings-section__group mb-10">
            <label class="text-right settings-section-input-offset justify-content-right">Paper Size:</label>
            <div class="settings-section__input max-w-200">
              <div class="d-flex align-items-center">
                <mat-select class="trg-outline" [class.w-200]="!showDPI" panelClass="trg-outline-dropdown min-w-200 max-w-200"
                            [(ngModel)]="paperSize" (ngModelChange)="modelChanged()">
                  <mat-option *ngFor="let ps of paperSizes" [value]="ps.id">{{showDPI ? ps.titleForImage : ps.title}}</mat-option>
                </mat-select>
                <ng-container *ngIf="showDPI">
                  <span class="mx-6">at</span>
                  <mat-select class="trg-outline" panelClass="trg-outline-dropdown" [(ngModel)]="imageDpi" (ngModelChange)="modelChanged()">
                    <mat-option *ngFor="let opt of imageDpis" [value]="opt.value">{{opt.title}}</mat-option>
                  </mat-select>
                  <span class="ml-6">DPI</span>
                </ng-container>
              </div>
              <span *ngIf="showDPI" class="fs-10 nowrap">{{getImageRenderAtText()}}</span>
            </div>
          </div>
          <div class="settings-section__group" *ngIf="features?.visualExport?.exportLayout">
            <label class="text-right settings-section-checkbox-offset justify-content-right">Include Header:</label>
            <div class="settings-section__input">
              <trg-checkbox appearance="square" [(value)]="includeHeader" (valueChange)="modelChanged()"></trg-checkbox>
            </div>
          </div>
          <div class="settings-section__group" *ngIf="features?.visualExport?.exportLayout">
            <label class="text-right settings-section-checkbox-offset justify-content-right">Include Footer:</label>
            <div class="settings-section__input">
              <trg-checkbox appearance="square" [(value)]="includeFooter" (valueChange)="modelChanged()"></trg-checkbox>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="c-grey-5" [hidden]="!failed && !success">
        <div *ngIf="failed" class="d-flex align-items-center c-red">
          <i class="fal fa-exclamation-circle i-14 mr-10"></i>
          <span>Failed to generate the requested document.</span>
        </div>
        <div *ngIf="success" class="d-flex align-items-center">
          <i class="fal fa-file-download i-14 mr-10"></i>
          <span>
            The document has been generated.<br />
            If the download does not start automatically, <a *ngIf="downloadUrl" [href]="downloadUrl" target="_blank" [download]="fileName" class="c-blue">click here</a>.
          </span>
        </div>
      </div>
      <div [hidden]="!exporting" style="flex: 1 0 0;">
        <app-spinner></app-spinner>
      </div>
      <div [hidden]="exporting || loading || failed || success" style="flex: 1 0 0;" class="d-flex align-items-end pb-20">
        <div class="d-flex align-items-center">
          <i class="fal fa-exclamation-circle mr-5 i-14"></i>
          <span>Any filters used will be applied to the export</span>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <div class="d-flex align-items-center justify-content-right" style="flex: 1 0 0">
      <button *ngIf="!success" trgButton color="outline" class="min-w-70" (click)="cancel()">Cancel</button>
      <button trgButton color="primary" class="min-w-80" (click)="next()" [disabled]="exporting || !valid || loading">
        <span *ngIf="!failed && !success">Export</span>
        <span *ngIf="failed">Retry</span>
        <span *ngIf="success">Close</span>
      </button>
    </div>
  </div>
</div>
